import { OrgTypes } from '@mode/shared/contract-common';
import { Action, ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as CollectionActions from './collection.actions';

export const collectionFeatureKey = 'collection';

export interface State {
  collections: ReadonlyArray<OrgTypes.Collection>;
  isCollectionsLoading: boolean;
  isCollectionsComplete: boolean;
  collectionsError: Error | null;
}

export const initialState: State = {
  collections: [],
  isCollectionsLoading: false,
  isCollectionsComplete: false,
  collectionsError: null,
};

export const isCollectionsLoadingReducer = createReducer(
  initialState.isCollectionsLoading,
  on(CollectionActions.loadCollections, (state) => true),
  on(CollectionActions.loadCollectionsSuccess, (state, action) => false),
  on(CollectionActions.loadCollectionsFailure, (state, action) => false)
);

export const isCollectionsCompleteReducer = createReducer(
  initialState.isCollectionsComplete,
  on(CollectionActions.loadCollections, (state) => false),
  on(CollectionActions.loadCollectionsSuccess, (state, action) => true),
  on(CollectionActions.loadCollectionsFailure, (state, action) => true)
);

export const collectionsReducer = createReducer(
  initialState.collections,
  on(CollectionActions.loadCollections, (state) => state),
  on(CollectionActions.loadCollectionsSuccess, (state, action) => action.collections),
  on(CollectionActions.loadCollectionsFailure, (state, action) => [])
);

export const collectionsErrorReducer = createReducer(
  initialState.collectionsError,
  on(CollectionActions.loadCollections, (state) => null),
  on(CollectionActions.loadCollectionsSuccess, (state, action) => null),
  on(CollectionActions.loadCollectionsFailure, (state, action) => action.error)
);

export const reducer: ActionReducerMap<State> = {
  collections: collectionsReducer,
  isCollectionsComplete: isCollectionsCompleteReducer,
  isCollectionsLoading: isCollectionsLoadingReducer,
  collectionsError: collectionsErrorReducer,
};
